module.exports = __webpack_public_path__ + "img/upload_event.c20727d9.png";